import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SyllabusQuery, SyllabusUserSubscriptionQuery } from '@examdojo/category/v2';
import { ErrorHandlerService } from '@examdojo/error-handling';
import { ExamDateService } from '@examdojo/exam-date';
import { combineLatest, distinctUntilChanged, EMPTY, switchMap } from 'rxjs';

@Injectable()
export class ExamDatesEffectService {
  constructor(
    private readonly examDateService: ExamDateService,
    private readonly syllabusQuery: SyllabusQuery,
    private readonly syllabusUserSubscriptionQuery: SyllabusUserSubscriptionQuery,
    private readonly errorHandlerService: ErrorHandlerService,
  ) {
    this.fetchExamDatesWhenSyllabusChanges().pipe(takeUntilDestroyed()).subscribe();
  }

  private fetchExamDatesWhenSyllabusChanges() {
    return combineLatest([
      this.syllabusQuery.activeIdAndCourseLevel$,
      this.syllabusUserSubscriptionQuery.activeCourseExamDateId$.pipe(distinctUntilChanged()),
    ]).pipe(
      switchMap(([{ syllabusId, courseLevel }, userExamDateId]) =>
        this.examDateService.fetchAll({
          syllabusAndCourseLevels: { syllabusId, courseLevel },
          includeIds: userExamDateId || undefined,
        }),
      ),
      this.errorHandlerService.catchHttpErrors(() => EMPTY),
    );
  }
}
